import { render, staticRenderFns } from "./BrandStory.vue?vue&type=template&id=dad3716c"
import script from "./BrandStory.vue?vue&type=script&lang=js"
export * from "./BrandStory.vue?vue&type=script&lang=js"
import style0 from "./BrandStory.vue?vue&type=style&index=0&id=dad3716c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports